import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ResultItem from './ResultItem';

const SearchResults = ({
	results,
	input,
	display,
	submitSearch,
	resultsMaxHeight,
	hasError,
	contextEnabled,
	appliedFilters,
	activeResultIndex,
	setActiveResultIndex
}) => {
	const { labels } = useSelector(state => state); // TODO: use common data hook

	if (hasError) {
		return null;
	}

	let searchContextText = null;
	if (contextEnabled && appliedFilters.length) {
		const filters = appliedFilters.map(filter =>
			filter.values.map(item => item.label)
		);
		searchContextText = labels.IN_CONTEXT_SEARCH.replace(
			'{{searchContext}}',
			[].concat(...filters).join(', ')
		);
	}

	if (
		results &&
		results.suggestions &&
		results.suggestions.length &&
		display
	) {
		return (
			<nav
				aria-label={labels.INV_TEXT_SEARCH_SUGGESTIONS_ARIA}
				className="overflow-auto"
				style={{
					maxHeight: resultsMaxHeight
				}}
			>
				{searchContextText ? <h4>{searchContextText}</h4> : null}
				<ol className="list-group">
					{results.suggestions.map((result, index) => {
						return (
							<ResultItem
								key={result.suggestion}
								submitSearch={submitSearch}
								{...{
									result,
									input,
									appliedFilters,
									contextEnabled
								}}
								active={activeResultIndex === index}
								onMouseOver={() => setActiveResultIndex(index)}
								onMouseOut={() => setActiveResultIndex(-1)}
							/>
						);
					})}
				</ol>
			</nav>
		);
	}
	return null;
};

SearchResults.propTypes = {
	results: PropTypes.shape({
		suggestions: PropTypes.arrayOf(
			PropTypes.shape({
				facetInfo: PropTypes.shape({}),
				suggestion: PropTypes.string,
				count: PropTypes.number
			})
		)
	}),
	input: PropTypes.string.isRequired,
	submitSearch: PropTypes.func.isRequired,
	display: PropTypes.bool.isRequired,
	resultsMaxHeight: PropTypes.number,
	hasError: PropTypes.bool,
	contextEnabled: PropTypes.bool.isRequired,
	appliedFilters: PropTypes.arrayOf(PropTypes.shape({})),
	activeResultIndex: PropTypes.number,
	setActiveResultIndex: PropTypes.func
};

SearchResults.defaultProps = {
	results: {},
	resultsMaxHeight: null,
	hasError: false,
	appliedFilters: []
};

export default SearchResults;
